import validate from "/usr/src/app/content/n3-spas-756fb472-513d-45bf-8a81-961c78efa2d0/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-756fb472-513d-45bf-8a81-961c78efa2d0/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}